import { render, staticRenderFns } from "./ModalUpdateOrCreateWebhook.vue?vue&type=template&id=b10f0340"
import script from "./ModalUpdateOrCreateWebhook.vue?vue&type=script&lang=js"
export * from "./ModalUpdateOrCreateWebhook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports